(function(root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
    return;
  }

  root.WallforgeEditStateMachine = factory();
})(typeof self !== 'undefined' ? self : this, function() {
  'use strict';

  var STATES = Object.freeze([
    'idle',
    'peek',
    'input',
    'processing',
    'review',
    'error',
    'timeout',
    'limit'
  ]);

  var BLOCKED_ATC_STATES = {
    processing: true,
    timeout: true
  };

  var TRANSITIONS = {
    idle: {
      DESIGN_READY: 'peek'
    },
    peek: {
      OPEN: 'input',
      RESET: 'idle'
    },
    input: {
      SUBMIT: 'processing',
      CLOSE: 'peek',
      RESET: 'idle',
      LIMIT: 'limit'
    },
    processing: {
      SUCCESS: 'review',
      FAIL: 'error',
      TIMEOUT: 'timeout',
      LIMIT: 'limit',
      CLOSE: 'peek'
    },
    review: {
      ACCEPT: 'peek',
      RETRY: 'input',
      FAIL: 'error',
      LIMIT: 'limit',
      CLOSE: 'peek'
    },
    error: {
      RETRY: 'input',
      CLOSE: 'peek',
      LIMIT: 'limit'
    },
    timeout: {
      RETRY: 'input',
      CLOSE: 'peek'
    },
    limit: {
      CLOSE: 'peek'
    }
  };

  function normalizeState(state) {
    var nextState = String(state || '').trim().toLowerCase();
    return STATES.indexOf(nextState) > -1 ? nextState : 'idle';
  }

  function normalizeEvent(eventName) {
    return String(eventName || '').trim().toUpperCase();
  }

  function reduceEditState(currentState, eventName) {
    var state = normalizeState(currentState);
    var eventKey = normalizeEvent(eventName);
    var transitionMap = TRANSITIONS[state] || {};
    return transitionMap[eventKey] || state;
  }

  function isAtcBlocked(state) {
    return Boolean(BLOCKED_ATC_STATES[normalizeState(state)]);
  }

  function getActionAvailability(state) {
    var normalized = normalizeState(state);

    return {
      canOpen: normalized === 'peek',
      canClose: normalized !== 'idle',
      canSubmitPrompt: normalized === 'input',
      canAcceptDraft: normalized === 'review',
      canRetry: normalized === 'review' || normalized === 'error' || normalized === 'timeout',
      atcBlocked: isAtcBlocked(normalized)
    };
  }

  function createController(initialState) {
    var state = normalizeState(initialState || 'idle');

    return {
      getState: function() {
        return state;
      },
      setState: function(nextState) {
        state = normalizeState(nextState);
        return state;
      },
      transition: function(eventName) {
        state = reduceEditState(state, eventName);
        return state;
      },
      getActions: function() {
        return getActionAvailability(state);
      }
    };
  }

  return {
    STATES: STATES,
    reduceEditState: reduceEditState,
    isAtcBlocked: isAtcBlocked,
    getActionAvailability: getActionAvailability,
    createController: createController
  };
});
